module.exports = "https://cdn.realtymogul.com/static/media/HIW_hero.1c1409f3.jpg";